import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useUserForgotPasswordData = () => {

    const getUserForgotPasswordData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}unsecure/user/forgot-password${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postUserForgotPasswordData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}unsecure/user/forgot-password${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}unsecure/user/forgot-password${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putUserForgotPasswordData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}unsecure/user/forgot-password${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchUserForgotPasswordData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}unsecure/user/forgot-password${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteUserForgotPasswordData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}unsecure/user/forgot-password${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getUserForgotPasswordData,
        postUserForgotPasswordData,
        patchUserForgotPasswordData,
        putUserForgotPasswordData,
        deleteUserForgotPasswordData
    };

};